module.exports = __webpack_public_path__ + "media/images/logo2_baloo-c6fab9cc650b63e25e85b93628d441e1.png";